exports.TrixEditor = require("./lib/react-trix").TrixEditor;



//////////////////
// WEBPACK FOOTER
// ./~/react-trix/main.js
// module id = ./node_modules/react-trix/main.js
// module chunks = 0